import React from "react";
import Tag from "../../../../../generic/tag";
import OverflowButton from "../../../../../generic/overflowButton";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";
import { IListObj } from "../../../../../types/genericTypes";

export interface ObOfsProps {
  data: Array<any>;
}

// heading for OFS Asset table
const heading = {
  symbol: "Symbol",
  qty: "Qty.",
  price: "Price",
  amount: "Total Value",
};

const ObOfs: React.FC<ObOfsProps> = () => {
  function onNavigationDropdownSelect(id: string | number) {
    //console.log(id);
  }

  const navigationDropdownOptions: Array<IListObj> = [
    { value: "Modify", display: "Modify" },
    { value: "cancel", display: "Cancel" },
    { value: "Convert", display: "Convert" },
  ];

  return (
    <div className="ofs_table ins_tabl">
      {/* ob OFS Header Row */}
      <ul className="hdr_row">
        <li>
          <div className="col time"> </div>
          <div className="col txn_typ"> </div>
          <div className="col sym">{heading.symbol}</div>
          <div className="col qty taRight">{heading.qty}</div>
          <div className="col price taRight">{heading.price}</div>
          <div className="col amt taRight">{heading.amount}</div>
          <div className="col sts"></div>
          <div className="col menu"></div>
        </li>
      </ul>

      {/* if history componenet need to show*/}

      <ul className="eq_hist_date hist_date">
        <li>14 October 2019</li>
      </ul>

      {/* ob OFS offer content Row */}

      <ul className="ofs_data ins_data">
        <li>
          <div className="col time">
            <span>11:34:12</span>
          </div>
          <div className="col txn_typ">
            <span>
              <Tag
                value="B"
                shape="mini_circle"
                color="red"
                height="22px"
                width="22px"
              />
            </span>
          </div>
          <div className="col sym">
            <span>RPOWER-RS</span>
          </div>
          <div className="col qty taRight">
            <span>50,000</span>
          </div>
          <div className="col price taRight">
            <span>₹10,99,271.60</span>
          </div>
          <div className="col amt taRight">
            <span>₹10,09,99,271.60</span>
          </div>
          <div className="col sts">
            <span>
              <Tag value="open" shape="chip" color="blue" />
            </span>
          </div>
          <div className="col menu">
            <OverflowButton
              defaultValue={"modify"}
              dropdownOptions={navigationDropdownOptions}
              onSelect={onNavigationDropdownSelect}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ObOfs;
